import { createContext } from "react";

const TodoContext = createContext(null)
export{
    TodoContext
}